import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["task", "subtaskGroup", "emptyState"]

  connect() {
    // Seleciona a primeira task por padrão
    const firstTask = this.taskTargets[0]
    if (firstTask) {
      this.select({ currentTarget: firstTask })
    }
  }

  select(event) {
    const taskElement = event.currentTarget
    const taskId = taskElement.dataset.taskId

    // Atualiza visual das tasks
    this.taskTargets.forEach(t => {
      t.classList.remove("bg-orange-50", "border-orange-400")
      t.classList.add("border-transparent")
    })
    taskElement.classList.add("bg-orange-50", "border-orange-400")
    taskElement.classList.remove("border-transparent")

    // Mostra/esconde subtarefas
    let hasVisible = false
    this.subtaskGroupTargets.forEach(group => {
      if (group.dataset.taskId === taskId) {
        group.classList.remove("hidden")
        hasVisible = true
      } else {
        group.classList.add("hidden")
      }
    })

    // Mostra/esconde empty state
    if (this.hasEmptyStateTarget) {
      if (hasVisible) {
        this.emptyStateTarget.classList.add("hidden")
      } else {
        this.emptyStateTarget.classList.remove("hidden")
      }
    }
  }
}
